import React from 'react';
import { Page, Text, View, Document, StyleSheet, Svg, Image } from '@react-pdf/renderer';
import FinbeLogo from '../../assets/logos/FinbeLogoAzul.png';
import styles from './DownloadParametricPDF.style';
import BepensaLogo from '../../assets/logos/bepensaLogo.png'
import { formatNumber } from "../../functions/formatPrice";
// Create Document Component
const DownloadParametricPDF = (props ) => {
    let result = props.Result;
    let data = props.dataCotizacion;
    const date = new Date();
    const address = `Mérida, Yucatán  ${date.toLocaleDateString()}`;
    const getMonthName = (monthNumber) => {
        const months = [
            "Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio",
            "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"
        ];
        return months[monthNumber];
    };
    
    const expirationDate = new Date(date.getFullYear(), date.getMonth() + 1, date.getDate());
    
    const day = expirationDate.getDate();
    const month = getMonthName(expirationDate.getMonth());
    const year = expirationDate.getFullYear();
    
    const expirateDate = `${day} de ${month} de ${year}`;
    return (
        <Document>
            <Page size="A4" style={styles.page}>
                <View style={styles.brandingSection}>
                    <View className={styles.brandingColumn1}>
                        <Image style={styles.logo} src={FinbeLogo} />
                    </View>
                    <View style={styles.brandingColumn2}>
                        <Text style = {styles.brandingText}>{data.quoteType ==0? 'Simulación de Arrendamiento' : 'Simulación de Crédito'}</Text>
                        <Text style = {styles.folio}>Folio: {data.folio}</Text>
                        <Text style = {styles.date}>{address}</Text>
                        <View style={styles.line}></View>
                    </View>
                </View>
                <View style={styles.clientSection}>
                    <View style={styles.clientInfo}>
                        <View>
                            {data.userType == 1? (
                                <Text style = {styles.clientInfoText}>
                                    Nombre del Cliente: <Text style = {styles.tableText}>{`${data.userFirstName +  ' ' + data.userSecondName + ' ' + data.userFirstLastName + ' ' + data.userSecondLastName}`}</Text>
                                </Text>
                            ):
                            (
                                <Text style = {styles.clientInfoText}>
                                    Nombre del Cliente: <Text style = {styles.tableText}>{`${data.userEnterprise}`}</Text>
                                </Text>
                            ) }
                            
                        </View>
                        <View>
                            <Text style = {styles.clientInfoText}>
                                Promotor: <Text style = {styles.tableText}>{data.quoteType == 0? 'CANAL ARRENDAMIENTO' : 'CANAL CREDITO'}</Text>
                            </Text>
                        </View>
                        <View>
                        {data.userType == 1? (
                            <Text style = {styles.clientInfoText}>
                                Teléfono: <Text style = {styles.tableText}>{data.userCellphone}</Text>
                            </Text>
                        ):
                        (
                            <Text style = {styles.clientInfoText}>
                                Teléfono: <Text style = {styles.tableText}>{data.legalRepresentativeCellphone}</Text>
                            </Text>
                        ) }
                        </View>
                    </View>
                    <View style={styles.clientInfo}>
                        <Text style = {styles.assetType}>{data.quoteType ==0? `${props.assetName}` : `Monto del credito` }</Text>
                        <Text style = {styles.amount}>{data.quoteType ==0? `$${formatNumber(data.assetPrice)}` : `$${formatNumber(data.credit)}` }</Text>
                        {data.quoteType === 1 &&(
                            <>  <Text style = {styles.creditInfoText}>{data.productTypeOption == 0? "Crédito simple" : "Crédito Revolvente"}</Text>
                                <Text style = {styles.creditInfoText}>Tasa base para simulación: TIIE + 14</Text>
                                <Text style = {styles.creditInfoText}>Plazo: {data.plazo}</Text>
                                <Text style = {styles.creditInfoText}>Comisión del 3% + IVA</Text>
                            </>
                        )}
                    </View>
                </View>
                {/* Tabla para Cotizaciones de arrendamiento */}
                {data.quoteType == 0 ?(<>
                    <View>
                        <Text style={styles.tableHeader}>Conceptos Financiados (incluye IVA)</Text>
                        <View style={styles.line}></View>
                    </View>
                    <View style={styles.tablelightGreyRow}>
                        <Text style={styles.tableText}>Valor del Equipo a Financiar </Text>
                        <Text style={styles.tableText}>{`$${formatNumber(result.valorEquipo)}`}</Text>
                    </View>
                    <View style={styles.tabledarkGreyRow}>
                        <Text style={styles.boldTableText}>Monto Total Financiado </Text>
                        <Text style={styles.boldTableText}>{`$${formatNumber(result.valorEquipo)}`}</Text>
                    </View>
                    <View>
                        <Text style={styles.tableHeader}>Pago Inicial</Text>
                        <View style={styles.line}></View>
                    </View>
                    <View style={styles.tablelightGreyRow}>
                        <Text style={styles.tableText}>Comisión por apertura</Text>
                        <Text style={styles.tableText}>{`$${formatNumber(result.comisionApertura)}`}</Text>
                    </View>
                    <View style={styles.tablelightGreyRow}>
                        <Text style={styles.tableText}>Anticipo</Text>
                        <Text style={styles.tableText}>{`$${formatNumber(result.Anticipo)}`}</Text>
                    </View>
                    <View style={styles.tabledarkGreyRow}>
                        <Text style={styles.boldTableText}>Total Pago Inicial (incluye IVA)</Text>
                        <Text style={styles.boldTableText}>{`$${formatNumber(result.pagoInicial)}`}</Text>
                    </View>
                    <View>
                        <Text style={styles.tableHeader}>Renta Mensual (no incluye IVA)</Text>
                        <View style={styles.line}></View>
                    </View>
                    <View style={styles.tablelightGreyRow}>
                        <Text style={styles.tableText}>Renta básica </Text>
                        <Text style={styles.tableText}>{`$${formatNumber(result.rent)}`}</Text>
                    </View>
                    <View style={styles.tabledarkGreyRow}>
                        <Text style={styles.boldTableText}>Total Pago Mensual</Text>
                        <Text style={styles.boldTableText}>{`$${formatNumber(result.rent)}`}</Text>
                    </View>
                </>):
                (<>
                    <View style={styles.table}>
                        <Text style={styles.columnHeader}>Periodo</Text>
                        <Text style={styles.columnHeader}>Saldo inicial</Text>
                        <Text style={styles.columnHeader}>Capital</Text>
                        <Text style={styles.columnHeader}>Interés</Text>
                        <Text style={styles.columnHeader}>Pago</Text>
                        <Text style={styles.columnHeader}>Saldo final</Text>
                    </View>
                        {props.CreditResult?.length > 0 && Array.isArray(props.CreditResult[0].terms) && props.CreditResult[0].terms.map(term => (
                        <View style={styles.table} key={term.term}>
                            <Text style={styles.column}>{term.term}</Text>
                            <Text style={styles.column}>{`$${formatNumber(term.initial_balance.toFixed(2))}`}</Text>
                            <Text style={styles.column}>{`$${formatNumber(term.capital.toFixed(2))}`}</Text>
                            <Text style={styles.column}>{`$${formatNumber((term.payment - term.capital).toFixed(2))}`}</Text>
                            <Text style={styles.column}>{`$${formatNumber(term.payment.toFixed(2))}`}</Text>
                            <Text style={styles.column}>{`$${formatNumber(term.final_balance.toFixed(2))}`}</Text>
                          </View>
                        ))}
                </>)}
                
                <View style={styles.footer} >
                    {data.quoteType === 0 ? (
                        <>
                            <Text style={styles.footerText}>a. La presente simulación estará vigente hasta el {expirateDate}</Text>
                            <Text style={styles.footerText}>b. La simulación de arrendamiento realizada aquí tiene únicamente propósitos 
                            informativos y comparativos. No implica una aprobación de crédito. El monto y la tasa precisos de su crédito 
                            estarán sujetos al cumplimiento de las políticas de FinBe ABC y a la aprobación final de su solicitud.</Text>
                            <Text style={styles.footerText}>c. La simulación de arrendamiento está sujeta a cambios sin previo aviso hasta 
                            la aceptación y firma del contrato.</Text>
                            <Text style={styles.footerText}>d. El seguro se cotizará al momento de la contratación.</Text>
                            <View style={styles.footerBranding}>
                                <View>
                                    <Text style={styles.footerBrandingText}>Calle 56-B No. 452 x 11 y 13 </Text>
                                    <Text style={styles.footerBrandingText}>Colonia Itzimná </Text>
                                    <Text style={styles.footerBrandingText}>Mérida, Yucatán C.P. 97100 </Text>
                                    <Text style={styles.footerBrandingText}>(999) 940 6778, (999) 940 6779</Text>
                                </View>
                            </View>
                        </>    
                    )
                    : (
                       <>
                            <Text style={styles.footerText}>a. La presente simulación estará vigente hasta el {expirateDate}</Text>
                            <Text style={styles.footerText}>b. La simulación de crédito realizada aquí tiene únicamente propósitos informativos y comparativos. 
                            No implica una aprobación de crédito. El monto y la tasa precisos de su crédito estarán sujetos al cumplimiento de las políticas de 
                            FinBe ABC y a la aprobación final de su solicitud.</Text>
                            <Text style={styles.footerText}>c. La simulación de crédito está sujeta a cambios sin previo aviso hasta la aceptación y firma del contrato.</Text>
                            <View style={styles.footerBranding}>
                                <View>
                                    <Text style={styles.footerBrandingText}>Calle 56-B No. 452 x 11 y 13 </Text>
                                    <Text style={styles.footerBrandingText}>Colonia Itzimná </Text>
                                    <Text style={styles.footerBrandingText}>Mérida, Yucatán C.P. 97100 </Text>
                                    <Text style={styles.footerBrandingText}>(999) 940 6778, (999) 940 6779</Text>
                                </View>
                            </View>
                        </>
                    )}
                </View>
            </Page>
        </Document>
    );
};
export default DownloadParametricPDF;